import { LitElement, css, html } from "lit";
import { customElement } from "lit/decorators.js";

@customElement("bp-caption")
export class Caption extends LitElement {
  static styles = css`
    :host {
      color: var(--color-gray);
      font-size: var(--font-size-xs);
    }

    ::slotted(a) {
      color: inherit;
      text-decoration: underline;
    }
  `;

  handleLinkClick(e: MouseEvent) {
    if (globalThis.window.BibleProjectApp) e.preventDefault();

    document.dispatchEvent(
      new CustomEvent("bp:external_link", {
        detail: {
          href: (e.currentTarget as HTMLAnchorElement).href,
        },
      }),
    );
  }

  handleSlotChange() {
    // Ensure all links are treated as "external"
    this.querySelectorAll("a").forEach((e) => {
      e.setAttribute("target", "_blank");
      e.removeEventListener("click", this.handleLinkClick);
      e.addEventListener("click", this.handleLinkClick);
    });
  }

  render() {
    return html`
      <figcaption>
        <slot @slotchange=${this.handleSlotChange}></slot>
      </figcaption>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-caption": Caption;
  }
}
